import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import { IData, IHttpResponse } from "_services/api/interface/HttpResponse";
import { IOptions } from "components/DropdownSelect";
import { tipoVeiculoOpcoesFipe } from "features/processo/utils/tipoVeiculoIntegracaoFipe";
import { useMemo, useState } from "react";

export function useIntegracaoFipe() {
  const [error, setError] = useState<IHttpResponse<IData | any>>();
  const [optionsMarcaModelo, setOptionsMarcaModelo] = useState<IOptions[]>([]);
  const statusBadRequest = 400;
  const api = useMemo(
    () => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW),
    []
  );
  const [stateTipoVeiculoOpcoesFipe, setStateTipoVeiculoOpcoesFipe] = useState<
    { fipe: string; label: string; marcas: any }[]
  >(tipoVeiculoOpcoesFipe);

  const buscarMarcasPorTipoVeiculo = async (tipoVeiculo: string) => {
    const tipoFipeEscolhido = checarTipoVeiculoPadraoFipe(tipoVeiculo);
    criarOptionsMarcaModelo([]);

    if (!tipoFipeEscolhido) {
      return new HttpResponse(true, statusBadRequest, {
        message: "Tipo de veículo não identificado",
      });
    }

    try {
      if (tipoFipeEscolhido.marcas) {
        criarOptionsMarcaModelo(tipoFipeEscolhido.marcas);
      } else {
        const { status, data } = await api.get(
          `/veiculo/fipe/${tipoFipeEscolhido.fipe}/marcas`
        );
        const response = new HttpResponse(false, status, data);
        setError(response);
        criarOptionsMarcaModelo(data);
        setStateTipoVeiculoOpcoesFipe(
          stateTipoVeiculoOpcoesFipe.map((tipo) => {
            if (tipo.fipe === tipoFipeEscolhido.fipe) {
              tipo.marcas = data;
            }
            return { ...tipo };
          })
        );
      }
    } catch (error) {
      const response = new HttpError<IData>(true, error);
      setError(response);
    }
  };

  const obterAnosVeiculosPorModelo = async (
    tipoVeiculo: string,
    marcaId: number | string,
    modeloId: number | string
  ) => {
    const tipoFipeEscolhido = checarTipoVeiculoPadraoFipe(tipoVeiculo);

    if (!tipoFipeEscolhido) {
      return new HttpResponse(true, statusBadRequest, {
        message: "Tipo de veículo não identificado",
      });
    }

    try {
      const { status, data } = await api.get(
        `/veiculo/fipe/${tipoFipeEscolhido}/marcas/${marcaId}/modelos/${modeloId}/years`
      );

      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    }
  };

  const checarTipoVeiculoPadraoFipe = (tipoVeiculo: string) => {
    const tipoEscolhido = stateTipoVeiculoOpcoesFipe.filter((opcao) =>
      [opcao.label, opcao.fipe].includes(tipoVeiculo)
    );

    if (tipoEscolhido.length) {
      return tipoEscolhido[0];
    }

    return null;
  };

  const criarOptionsMarcaModelo = (data: any) => {
    const options: IOptions[] = [];
    data.map((marca: any) => {
      if (marca.modelos && Array.isArray(marca.modelos)) {
        marca.modelos.map((modelo: any) => {
          options.push({
            value: `${marca.name.toUpperCase()} / ${modelo.name.toUpperCase()}`,
            label: `${marca.name.toUpperCase()} / ${modelo.name.toUpperCase()}`,
          });
        });
      }
    });
    setOptionsMarcaModelo(options);
  };

  return {
    buscarMarcasPorTipoVeiculo,
    obterAnosVeiculosPorModelo,
    checarTipoVeiculoPadraoFipe,
    error,
    optionsMarcaModelo,
  };
}
